import {
  ESimulatorAMS275912SteelClass,
} from '@/types/simulator.ts';

const details: Record<ESimulatorAMS275912SteelClass, string> = {
  [ESimulatorAMS275912SteelClass.GROUP_0]: 'HLSA, Plain Carbon - 5.1 to 25 µm',
  [ESimulatorAMS275912SteelClass.GROUP_1]: '4140, 4340, Nitralloy 135 - Low Alloy 5.1 to 25, Tool Steels 2.5 to 15',
  [ESimulatorAMS275912SteelClass.GROUP_2]: 'Cast Iron - 5.1 to 25 µm',
};

export default {
  details,
};
